import * as Sentry from '@sentry/browser'

import { amplitude } from '@/main'
import { INFRASTRUCTURE_ENVIRONMENT_TYPE } from '@/constants'

const INTERVAL_MS = 300000 // Run memory checks every 5 minutes
const USER_AGENT_SPECIFIC_MEMORY_THRESHOLD_MB = 1500
const MEMORY_THRESHOLD_MB = 500
const eventMessage = 'High Memory Usage'

const sendAmplitudeEvent = (memoryUsageMB: number, threshold: number) => {
  if (
    INFRASTRUCTURE_ENVIRONMENT_TYPE === 'prod' ||
    INFRASTRUCTURE_ENVIRONMENT_TYPE === 'stage'
  ) {
    amplitude.track(eventMessage, {
      threshold,
      memoryUsageMB: Math.round(memoryUsageMB),
    })
  }
}

// https://web.dev/articles/monitor-total-page-memory-usage
export function setupMemoryMonitoring() {
  console.debug(
    `Starting memory monitoring with ${Math.round(INTERVAL_MS / 60000)} minute intervals`,
  )

  async function checkMemoryUsage() {
    try {
      const result = await performance.measureUserAgentSpecificMemory()
      const memoryUsageMB = result.bytes / (1024 * 1024)

      if (memoryUsageMB > USER_AGENT_SPECIFIC_MEMORY_THRESHOLD_MB) {
        // amplitude event
        sendAmplitudeEvent(
          memoryUsageMB,
          USER_AGENT_SPECIFIC_MEMORY_THRESHOLD_MB,
        )
      }
    } catch (error) {
      console.debug('Error during memory measurement:', error)
    }

    try {
      if (performance.memory) {
        const memoryUsage = performance.memory.usedJSHeapSize / (1024 * 1024)
        if (memoryUsage > MEMORY_THRESHOLD_MB) {
          // amplitude event
          sendAmplitudeEvent(memoryUsage, MEMORY_THRESHOLD_MB)
          // sentry message
          Sentry.captureMessage(eventMessage, {
            level: 'warning',
            extra: {
              memoryUsageMB: Math.round(memoryUsage),
              totalHeapSizeMB: Math.round(
                performance.memory.totalJSHeapSize / (1024 * 1024),
              ),
              heapLimitMB: Math.round(
                performance.memory.jsHeapSizeLimit / (1024 * 1024),
              ),
            },
          })
        }
      }
    } catch (error) {
      console.debug('Error during memory measurement:', error)
    }
  }

  setInterval(() => {
    checkMemoryUsage().catch((error) =>
      console.debug('Error during memory measurement:', error),
    )
  }, INTERVAL_MS)
}
